var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.092,
    y1: 1,
    x2: 0.79,
    y2: -0.731,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004f71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a719e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2964",
    "data-name": "Group 2964",
    transform: "translate(-627 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(627 285)",
    fill: "#fff",
    stroke: "#004f71",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Change_password",
    transform: "translate(617.806 275.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41126",
    "data-name": "Path 41126",
    d: "M126.4,232.708v20.885a5.168,5.168,0,0,0,5.153,5.153h39.16a5.167,5.167,0,0,0,5.153-5.153V232.708a5.167,5.167,0,0,0-5.153-5.153h-39.16A5.168,5.168,0,0,0,126.4,232.708Zm38.473,6.407a4.036,4.036,0,1,1-4.036,4.036A4.036,4.036,0,0,1,164.874,239.115Zm-13.74,0a4.036,4.036,0,1,1-4.036,4.036,4.036,4.036,0,0,1,4.036-4.036Zm-13.74,0a4.036,4.036,0,1,1-4.036,4.036,4.036,4.036,0,0,1,4.036-4.036Z",
    transform: "translate(-85.419 -166.965)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41127",
    "data-name": "Path 41127",
    d: "M201.8,107.7v-6.871a16.728,16.728,0,1,0-33.455,0V107.7h3.777v-6.871a12.95,12.95,0,1,1,25.9,0V107.7Z",
    transform: "translate(-119.36 -50.887)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/reset-password.69373f10.svg";
export { ForwardRef as ReactComponent };